import * as React from "react";
import {RouterView, LoadingViewState} from "../../RouterView";
import {kernel} from "../../../../ioc/IOCHelper";
import {HandHistoryService} from "../../../../service/poker/history/HandHistoryService";
import {Symbols} from "../../../../ioc/Symbols";
import {HistoricHandWrapper} from "../../../../../generated/protocol";
import {Hand} from "../../../poker/history/Hand";
import {Link} from "react-router";


interface State extends LoadingViewState {
    handWrapper?: HistoricHandWrapper;
}

interface Props {
    params: { id: string }
}

export class HandView extends RouterView<Props, State> {

    service: HandHistoryService;

    constructor(props: Props) {
        super(props);
        this.service = kernel.get<HandHistoryService>(Symbols.HandHistoryService);
    }

    loadContent(): Promise<any> | void {
        return this.service.getHand(this.props.params.id).then((res: HistoricHandWrapper) => {
            this.setState({handWrapper: res})
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.params.id != this.props.params.id) {
            this.refreshContent();
        } else {
            super.componentDidUpdate(prevProps, prevState);
        }
    }

    isShowContentWhenOnRefresh(): boolean {
        return true;
    }


    renderContent(): JSX.Element {

        var previousHandId = this.state.handWrapper.previousHandId;
        var nextHandId = this.state.handWrapper.nextHandId;
        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>Hand</h1>
                    </div>
                </div>
                <div className="wrapper wrapper-content animated" style={{opacity: this.state.loading ? 0.5 : 1}}>
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="pull-right pager-buttons">
                                {previousHandId &&
                                <Link className="btn btn-primary" to={"/hand/" + previousHandId}>Previous Hand</Link>}
                                {!previousHandId && <a className="btn btn-default disabled">Previous Hand</a>}
                                {nextHandId &&
                                <Link className="btn btn-primary" to={"/hand/" + nextHandId}>Next Hand</Link>}
                                {!nextHandId && <a className="btn btn-default disabled">Next Hand</a>}
                            </div>
                        </div>
                    </div>
                    <Hand hand={this.state.handWrapper.hand}/>
                </div>
            </div>
        );
    }


}


// WEBPACK FOOTER //
// ./src/app/ui/view/poker/history/HandView.tsx